module.exports = __webpack_public_path__ + "static/media/13_l_stol_2.71_69.07.64f58410.png";